export const INTEGRATE_MESSAGE = {
  prevCheck: '계정을 통합 하시겠습니까?',
  success: '계정통합이 완료되었습니다.',
  accountComplete: '이미 통합된 계정입니다.',
  accountNotFound: '가입된 계정이 아닙니다.'
};
